import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueMq from 'vue-mq'
import VueFormWizard from 'vue-form-wizard'

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueFormWizard);

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 577,
    md: 769,
    lg: Infinity,
  },
  defaultBreakpoint: 'sm' // customize this for SSR
});

import('./filters');
import('./assets/scss/style.scss');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
